import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { logEvent } from '../lib/analytics';

const FloatingCallButton: React.FC = () => {
  const phoneNumber = '+34600238283';
  const { t } = useTranslation();
  
  const whatsappMessage = encodeURIComponent(t('whatsapp.message'));

  const handleCallClick = () => {
    logEvent('Contact', 'Click', 'Floating Call Button');
  };

  const handleWhatsAppClick = () => {
    logEvent('Contact', 'Click', 'Floating WhatsApp Button');
  };
  
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
      <a
        href={`https://wa.me/${phoneNumber.replace('+', '')}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleWhatsAppClick}
        className="bg-green-500 hover:bg-green-600 text-white font-bold p-4 rounded-full shadow-lg transition-all duration-200 transform hover:scale-105 flex items-center gap-2"
        aria-label={t('whatsapp.label')}
      >
        <MessageCircle className="w-6 h-6" />
        <span className="hidden md:inline">WhatsApp</span>
      </a>
      <a
        href={`tel:${phoneNumber}`}
        onClick={handleCallClick}
        className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold p-4 rounded-full shadow-lg transition-all duration-200 transform hover:scale-105 flex items-center gap-2"
        aria-label={t('hero.callNow')}
      >
        <Phone className="w-6 h-6" />
        <span className="hidden md:inline">{t('hero.callNow')}</span>
      </a>
    </div>
  );
};

export default FloatingCallButton;